module.exports = __webpack_public_path__ + "assets/img/32_624.b6627bdc.jpg";